<div class="item-numbers-container">
    <nav class="breadcrumbs">
        <a class="crumb crumb-link" (click)="goToExtensions()">
            <i class="fa fa-chevron-left"></i>&nbsp;{{ "extensions.breadcrumbRoot" | translate }}
        </a>
        <span class="crumb-sep">/</span>
        <a class="crumb crumb-link" (click)="goToContractDetails()">{{ ownerLabel }}</a>
        <span class="crumb-sep">/</span>
        <span class="crumb current">{{ contractDetailsLabel }}</span>
    </nav>
    <div class="item-numbers-header">
        <div class="headings">
            <h3 class="page-title">{{ taskTitle }}</h3>
            <p class="page-subtitle">{{ "itemNumbers.heading" | translate: { owner: ownerLabel } }}</p>
        </div>
        <button
            class="btn btn-primary btn-online-primary"
            (click)="openModal()"
        >
            {{ "itemNumbers.createNewTitle" | translate }}
        </button>
    </div>
    <div class="grid-container">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [rowData]="itemNumberList"
            [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef"
            (cellEditingStarted)="onCellEditingStarted($event)"
            (cellEditingStopped)="onCellEditingStopped($event)"
            [getRowStyle]="getRowStyle"
            (gridReady)="onGridReady($event)"
            [stopEditingWhenCellsLoseFocus]="true"
            [enableBrowserTooltips]="true"
        />
    </div>
</div>
